import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(
	searchTerm: string | undefined,
	showOnlyDeleted: boolean
): Promise<Optional<ResponseBaseIngredient[]>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/BaseIngredient/StartingWith`;
	const params: Parameter = {
		SearchTerm: searchTerm,
		ShowOnlyDeleted: showOnlyDeleted,
	};
	return axios
		.get(url, {
			params: params,
		})
		.toOptionalMapped((x) => x.data.baseIngredients);
}

interface Parameter {
	SearchTerm?: string;
	ShowOnlyDeleted: boolean;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	baseIngredients: ResponseBaseIngredient[];
};

export type ResponseBaseIngredient = {
	id: string;
	description: string;
};
